#import "../fragments/chat-settings-knowledge-fragment.graphql"

query GetChatSettingsKnowledge {
    chatSettings {
        ...ChatSettingsKnowledgeFragment
    }
}
